import FBody from '@/plugins/form/FBody';
import FDictionaryCountry from '@/modules/Dictionary/Country/Select';
import FDictionaryCity from '@/modules/Dictionary/City/Select';

export default class extends FBody {
  from = new FDictionaryCity({
    label: 'Город отправления',
    required: true,
    isDeparture: true,
  });

  country = new FDictionaryCountry({
    label: 'Страна прибытия',
    required: true,
  });

  city = new FDictionaryCity({
    label: 'Город прибытия',
    required: true,
    country: this.country,
  });

  constructor(props = {}) {
    super(props);
    this.tour = props.parent;
    this.setItemFrom();
    this.setItemCountry();
    this.setItemCity();
  }

  get data() {
    const data = super.data;
    return {
      DepartureCityId: data.from || null,
      CountryId: data.country || null,
      CityId: data.city || null,
    };
  }

  set data(data) {
    this.from.set(data?.DepartureCityId ? {
      value: data.DepartureCityId,
      label: data.DepartureCityName,
    } : null);
    this.country.set(data?.CountryId ? {
      value: data.CountryId,
      label: data.CountryName,
    } : null);
    this.city.set(data?.CityId ? {
      value: data.CityId,
      label: data.CityName,
    } : null);
  }

  setItemFrom() {
    this.setItem('from', this.from);
  }

  setItemCountry() {
    this.setItem('country', this.country);
  }

  setItemCity() {
    this.setItem('city', this.city);
  }

  set(value = {}) {
    this.from.set(value.from || null);
    this.country.set(value.country || null);
    this.city.set(value.city || '');
    return this;
  }
}
